import React, { Component } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import TextField from "@mui/material/TextField";
import { Calendar } from "primereact/calendar";
import { SecondaryPackingRptActions } from "../../actions";
import { connect } from "react-redux";
import tableRequest from "../../models/tableRequest.js";
import { Toast } from "primereact/toast";
import { CSVLink } from "react-csv";
import { Dropdown } from "primereact/dropdown";

class SecondaryPackingReport extends Component {
  constructor(props) {
    super(props);
    this.csvLink = React.createRef();
    this.tblResponse = new tableRequest();
    this.tblResponse.PageSize = 10;
    this.onPage = this.onPage.bind(this);
    this.onSort = this.onSort.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.FilterData = this.FilterData.bind(this);
    this.searchFilter = this.searchFilter.bind(this);
    this.Export = this.Export.bind(this);
    this.state = {
      loading: false,
      FromDate: new Date(),
      ToDate: new Date(),
      first: 0,
      rows: 10,
      totalRecords: 0,
      globalFilter: null,
      visible: false,
      sortOrder: "",
      datalist: [],
      UserId: 0
    };
  }

  componentDidMount() {
    var date = new Date();
    date.setHours(0, 0, 0, 0);
    date.setDate(date.getDate() - 7);
    this.tblResponse.FromDate = date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit"
    });
    this.tblResponse.ToDate = new Date().toLocaleDateString("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit"
    });
    this.setState({
      FromDate: date,
      ToDate: new Date()
    });
    this.tblResponse.DealerId = this.state.UserId;
    this.props.fetchApi(this.tblResponse);
    this.props.GetVendorListDDL(sessionStorage.getItem("UserData"));
  }

  componentDidUpdate(prevProps) {
    if (prevProps.SecondaryPackingList !== this.props.SecondaryPackingList) {
      // this.props.myProp has a different value
      if (this.props.SecondaryPackingList) {
        debugger;
        var e = this.props.SecondaryPackingList;
        this.setState({
          totalRecords: parseInt(e[0].TotalRows)
        });
      }
    }
    if (
      this.state.Download &&
      this.props.IsDownload >= 1 &&
      prevProps.IsDownload != this.props.IsDownload
    ) {
      setTimeout(() => {
        this.csvLink.current.link.click();
      }, 3000);
      this.setState({
        Download: false
      });
    }
  }

  GetOrderBooking() {
    let ToDt = new Date();
    let FrmDt = new Date();
    FrmDt.setDate(ToDt.getDate() - 7);
    const myFmDt = this.getCurrentDateYYYYMMDD(FrmDt);
    const myToDt = this.getCurrentDateYYYYMMDD(ToDt);
    this.tblResponse.FromDate = myFmDt;
    this.tblResponse.ToDate = myToDt;
    this.props.fetchApi(this.tblResponse);
  }

  FilterData() {
    this.tblResponse.FromDate = this.state.FromDate.toLocaleDateString(
      "en-US",
      {
        year: "numeric",
        month: "2-digit",
        day: "2-digit"
      }
    );
    this.tblResponse.ToDate = this.state.ToDate.toLocaleDateString("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit"
    });
    this.tblResponse.DealerId = this.state.UserId;
    this.props.fetchApi(this.tblResponse);
  }

  getCurrentDateYYYYMMDD(dt) {
    var dd = String(dt.getDate()).padStart(2, "0");
    var mm = String(dt.getMonth() + 1).padStart(2, "0");
    var yyyy = dt.getFullYear();
    dt = yyyy + "/" + mm + "/" + dd;
    return dt;
  }

  handleChange(event) {
    const { name, value } = event.target;
    switch (name) {
      case "FromDate":
        if (value === null || !(value instanceof Date)) {
          this.formIsValid = false;
          // this.refs.Messchild.showError("Please select from date.");
          this.toast.show({
            severity: "error",
            summary: "Error Message",
            detail: "Please select from date.",
            life: 3000
          });
          return;
        } else if (
          !value
            .toLocaleDateString("en-US", {
              year: "numeric",
              month: "2-digit",
              day: "2-digit"
            })
            .match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/)
        ) {
          this.formIsValid = false;
          this.toast.show({
            severity: "error",
            summary: "Error Message",
            detail: "Please enter only date.",
            life: 3000
          });
          // this.refs.Messchild.showError("Please enter only date.");
          return;
        } else if (value instanceof Date && this.state.ToDate instanceof Date) {
          const startDate = value;
          const endDate = this.state.ToDate;
          if (!(Date.parse(startDate) <= Date.parse(endDate))) {
            this.formIsValid = false;
            this.toast.show({
              severity: "error",
              summary: "Error Message",
              detail: "From date must be less than to date.",
              life: 3000
            });
            // this.refs.Messchild.showError("From date must be less than to date.");
            return;
          }
        }
        break;
      case "ToDate":
        if (value === null || !(value instanceof Date)) {
          this.formIsValid = false;
          this.toast.show({
            severity: "error",
            summary: "Error Message",
            detail: "Please select to date.",
            life: 3000
          });
          // this.refs.Messchild.showError("Please select to date.");
          return;
        } else if (
          !value
            .toLocaleDateString("en-US", {
              year: "numeric",
              month: "2-digit",
              day: "2-digit"
            })
            .match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/)
        ) {
          this.formIsValid = false;
          this.toast.show({
            severity: "error",
            summary: "Error Message",
            detail: "Please enter only date.",
            life: 3000
          });
          // this.refs.Messchild.showError("Please enter only date.");
          return;
        } else if (
          value instanceof Date &&
          this.state.FromDate instanceof Date
        ) {
          const startDate = this.state.FromDate;
          const endDate = value;
          if (!(Date.parse(startDate) <= Date.parse(endDate))) {
            this.formIsValid = false;
            this.toast.show({
              severity: "error",
              summary: "Error Message",
              detail: "To date must be greater than from date.",
              life: 3000
            });
            // this.refs.Messchild.showError("To date must be greater than from date.");
            return;
          }
        }
        break;
      default:
        break;
    }
    this.setState({ [name]: value });
  }

  //to lazy load
  getLazyLoadingValues(event) {
    this.setState({ rows: event.rows, first: event.first });
    this.tblResponse.PageSize = event.rows;
    this.tblResponse.First = event.first + 1;
    this.tblResponse.IsActive = true;
    this.tblResponse.SearchValue = event.globalFilter ? event.globalFilter : "";
    this.tblResponse.SortColumn = event.sortField;
    this.tblResponse.DealerId = this.state.UserId;
    this.tblResponse.SortOrder = event.sortOrder === 1 ? "ASC" : "DESC";
    this.tblResponse.FromDate = this.state.FromDate.toLocaleDateString(
      "en-US",
      {
        year: "numeric",
        month: "2-digit",
        day: "2-digit"
      }
    );
    this.tblResponse.ToDate = this.state.ToDate.toLocaleDateString("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit"
    });
  }

  onPage(event) {
    this.props.loadingData(true);
    //imitate delay of a backend call
    setTimeout(() => {
      this.getLazyLoadingValues(event);
      this.props.fetchApi(this.tblResponse);
    }, 250);
  }

  Export() {
    this.tblResponse.PageSize = -1;
    this.tblResponse.First = 1;
    this.tblResponse.IsActive = true;
    this.tblResponse.SearchValue =
      this.state.globalFilter == null ? "" : this.state.globalFilter;
    this.tblResponse.SortColumn = "CreatedDt";
    this.tblResponse.DealerId = this.state.UserId;
    this.tblResponse.SortOrder = "DESC";
    this.tblResponse.FromDate = this.state.FromDate.toLocaleDateString(
      "en-US",
      {
        year: "numeric",
        month: "2-digit",
        day: "2-digit"
      }
    );
    this.tblResponse.ToDate = this.state.ToDate.toLocaleDateString("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit"
    });
    this.props.exportData(this.tblResponse);
    this.setState({
      Download: true
    });
  }

  //to search
  searchFilter(e) {
    this.props.loadingData(true);
    this.setState({
      sortOrder: this.state.sortOrder === 1 ? 2 : 1,
      globalFilter: e.target.value
    });
    this.tblResponse.SortOrder = this.state.sortOrder === 1 ? "DESC" : "ASC";
    this.tblResponse.DealerId = this.state.UserId;
    this.tblResponse.FromDate = this.state.FromDate.toLocaleDateString(
      "en-US",
      {
        year: "numeric",
        month: "2-digit",
        day: "2-digit"
      }
    );
    this.tblResponse.ToDate = this.state.ToDate.toLocaleDateString("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit"
    });
    this.tblResponse.SearchValue = e.target.value;
    this.props.fetchApi(this.tblResponse);
  }

  //to sort
  onSort(event) {
    this.props.loadingData(true);
    this.setState({ sortOrder: this.state.sortOrder === 1 ? 2 : 1 });
    const sortField =
      event.multiSortMeta[0].field === "CreatedDate"
        ? "CreatedDate"
        : event.multiSortMeta[0].field;
    this.tblResponse.SortColumn = sortField ? sortField : "";
    this.tblResponse.SortOrder = this.state.sortOrder === 1 ? "DESC" : "ASC";
    this.tblResponse.DealerId = this.state.UserId;
    this.tblResponse.FromDate = this.state.FromDate.toLocaleDateString(
      "en-US",
      {
        year: "numeric",
        month: "2-digit",
        day: "2-digit"
      }
    );
    this.tblResponse.ToDate = this.state.ToDate.toLocaleDateString("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit"
    });
    this.props.fetchApi(this.tblResponse);
  }

  render() {
    return (
      <div className="datatable-filter-demo">
        <Toast ref={(el) => (this.toast = el)} />
        <div className="row mb-3">
          <div className="col-md-3">
            <h4 className="pl-2">Secondary Packing Report</h4>
          </div>
          <div className="col-md-9">
            <div className="row text-right">
              <div className="col-md-2">
                <Calendar
                  placeholder="From Date"
                  name="FromDate"
                  showIcon="true"
                  value={this.state.FromDate}
                  onChange={this.handleChange}
                ></Calendar>
              </div>
              <div className="col-md-2">
                <Calendar
                  placeholder="To Date"
                  name="ToDate"
                  showIcon="true"
                  value={this.state.ToDate}
                  onChange={this.handleChange}
                ></Calendar>
              </div>
              <div className="col-md-3 text-left">
                <Dropdown
                  value={this.state.UserId}
                  onChange={(e) => {
                    this.handleChange(e);
                  }}
                  options={this.props.VendorDDL}
                  optionValue="value"
                  optionLabel="label"
                  className="form-control custom-select"
                  placeholder="Select Vendor"
                  name="UserId"
                  filter
                />
              </div>
              <div className="col-md-2 text-center">
                <button
                  type="button"
                  onClick={this.FilterData}
                  className="btn btn-primary p-2 pl-2 pr-2 buttone"
                >
                  Submit
                </button>
                &nbsp;
                <CSVLink
                  data={this.props.List}
                  headers={this.state.headers}
                  filename={"Secondary Packing Report.csv"}
                  target="_blank"
                  ref={this.csvLink}
                />
                <button
                  onClick={this.Export}
                  className="btn btn-success p-2 pr-2 pl-2 buttone"
                >
                  Export
                </button>
              </div>
              <div className="col-md-3">
                <TextField
                  id="standard-basic"
                  size="small"
                  variant="outlined"
                  className="fullwidth"
                  label="Search"
                  onInput={this.searchFilter}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="card">
          <DataTable
            value={this.props.SecondaryPackingList} //chngs
            scrollable
            responsive={true}
            globalFilter={this.state.globalFilter}
            emptyMessage="No Data found."
            sortMode="multiple"
            paginator={true}
            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
            rows={this.state.rows}
            style={{ width: "100%" }}
            rowsPerPageOptions={[10, 20, 50, 100]}
            totalRecords={this.state.totalRecords}
            lazy={true}
            first={this.state.first}
            onPage={this.onPage}
            onSort={this.onSort}
            loading={this.props.loading}
            ref={(el) => {
              this.dt = el;
            }}
          >
            <Column
              field="CartonId"
              style={{ width: "25%" }}
              disabled
              header="Carton Number"
              sortable
            ></Column>
            <Column
              style={{ width: "25%" }}
              field="ProductName"
              header="Product Name"
              sortable
            ></Column>
            <Column
              style={{ width: "10%" }}
              field="TotalQty"
              disabled
              header="Total Qty"
              sortable
            ></Column>
            <Column
              style={{ width: "20%" }}
              field="UserName"
              header="User Name"
              sortable
            ></Column>
            <Column
              style={{ width: "20%" }}
              field="CreatedDt"
              header="Created Date"
              sortable
            ></Column>
          </DataTable>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    SecondaryPackingList: state.SecondaryPackingReport.secondaryitems,
    VendorDDL:
      state.SecondaryPackingReport.vendorDDL == undefined
        ? []
        : state.SecondaryPackingReport.vendorDDL,
    List:
      state.SecondaryPackingReport.exportitems == undefined
        ? []
        : state.SecondaryPackingReport.exportitems,
    loading: state.SecondaryPackingReport.loding,
    IsDownload: state.SecondaryPackingReport.isDownload
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchApi: (obj) => {
      dispatch(SecondaryPackingRptActions.getAll(obj));
    },
    loadingData: (isLoding) =>
      dispatch(SecondaryPackingRptActions.loadingData(isLoding)),
    exportData: (obj) => dispatch(SecondaryPackingRptActions.exportData(obj)),
    GetVendorListDDL: (UserId) =>
      dispatch(SecondaryPackingRptActions.GetVendorListDDL(UserId))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SecondaryPackingReport);
